/**
 * Enforces teleop-commands' own wire-domain invariant: a `VelocityDemand` is always
 * −1…1 per axis before it's scaled to SI. Raw-input interpretation (dead zone, discrete
 * key/button → velocity mapping) belongs to teleop-input, not here.
 */

import type { VelocityDemand } from "../../types/commands";

function clampAxis(value: number): number {
  return Math.max(-1, Math.min(1, value));
}

/** Clamp normalized stick demand to −1…1 per axis. `steer_angle` falls back to `vy`
 * when not set explicitly — a rover has no lateral axis of its own, so its steering
 * demand rides the same shared input domain's `vy` (see MotionStream, which is the
 * only caller that ever reads `steer_angle` off the result). */
export function clampVelocity(v: VelocityDemand): Required<VelocityDemand> {
  return {
    vx: clampAxis(v.vx ?? 0),
    vy: clampAxis(v.vy ?? 0),
    vyaw: clampAxis(v.vyaw ?? 0),
    steer_angle: clampAxis(v.steer_angle ?? v.vy ?? 0),
  };
}
